import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a79505e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "modal_add_hs_code",
  ref: "addHsCodeModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-900px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_add_hs_code_header"
}
const _hoisted_5 = { class: "fw-bolder" }
const _hoisted_6 = {
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_9 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_modal_add_hs_code_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#kt_modal_add_hs_code_header",
  "data-kt-scroll-wrappers": "#kt_modal_add_hs_code_scroll",
  "data-kt-scroll-offset": "300px"
}
const _hoisted_10 = { class: "row mb-7" }
const _hoisted_11 = { class: "col-md-6 form-group mb-7" }
const _hoisted_12 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_13 = { class: "col-md-6 form-group mb-7" }
const _hoisted_14 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_15 = { class: "col-md-6 form-group mb-7" }
const _hoisted_16 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_17 = { class: "col-md-6 form-group mb-7" }
const _hoisted_18 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_19 = { class: "col-md-6 form-group mb-7" }
const _hoisted_20 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_21 = { class: "col-md-6 form-group mb-7" }
const _hoisted_22 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_23 = { class: "col-md-6 form-group mb-7" }
const _hoisted_24 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_25 = { class: "col-md-6 form-group mb-7" }
const _hoisted_26 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_27 = { class: "modal-footer flex-center" }
const _hoisted_28 = { class: "svg-icon svg-icon-3 ms-0 me-2" }
const _hoisted_29 = ["disabled"]
const _hoisted_30 = { class: "indicator-label" }
const _hoisted_31 = { class: "svg-icon svg-icon-3 ms-0 me-2" }
const _hoisted_32 = { class: "indicator-progress" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.editId
                ? _ctx.t("hsCodeManagement.editHsCode")
                : _ctx.t("hsCodeManagement.addHsCode")), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createVNode(_component_el_form, {
          onSubmit: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
          model: _ctx.formData,
          rules: _ctx.rules,
          ref: "formRef"
        }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.t("dsSkuManagement.brand")), 1),
                    _createVNode(_component_el_form_item, { prop: "brand_id" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          ref: "selectBrand",
                          modelValue: _ctx.formData.brand_id,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.brand_id) = $event)),
                          clearable: "",
                          filterable: "",
                          "remote-show-suffix": "",
                          remote: "",
                          "remote-method": _ctx.searchBrandSourceItems,
                          loading: _ctx.options.brandLoading,
                          placeholder: _ctx.t('common.enterKeyword'),
                          disabled: !!_ctx.editId
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.brandOptions, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "remote-method", "loading", "placeholder", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.t("hsCodeManagement.brandArticleNo")), 1),
                    _createVNode(_component_el_form_item, { prop: "brand_article_no" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.brand_article_no,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.brand_article_no) = $event)),
                          type: "text",
                          placeholder: _ctx.t('common.plsEnter'),
                          readonly: !!_ctx.editId
                        }, null, 8, ["modelValue", "placeholder", "readonly"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.t("hsCodeManagement.category")), 1),
                    _createVNode(_component_el_form_item, { prop: "category" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.category,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.category) = $event)),
                          type: "text",
                          placeholder: _ctx.t('common.plsEnter'),
                          readonly: !!_ctx.editId
                        }, null, 8, ["modelValue", "placeholder", "readonly"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.t("hsCodeManagement.sex")), 1),
                    _createVNode(_component_el_form_item, { prop: "sex" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.formData.sex,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.sex) = $event)),
                          clearable: "",
                          placeholder: _ctx.t('common.plsSelect'),
                          disabled: !!_ctx.editId
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.sex, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "placeholder", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.t("hsCodeManagement.color")), 1),
                    _createVNode(_component_el_form_item, { prop: "color" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.color,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.color) = $event)),
                          type: "text",
                          placeholder: _ctx.t('common.plsEnter'),
                          readonly: !!_ctx.editId
                        }, null, 8, ["modelValue", "placeholder", "readonly"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.t("hsCodeManagement.material")), 1),
                    _createVNode(_component_el_form_item, { prop: "material" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.material,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.material) = $event)),
                          type: "text",
                          placeholder: _ctx.t('common.plsEnter'),
                          readonly: !!_ctx.editId
                        }, null, 8, ["modelValue", "placeholder", "readonly"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.t("hsCodeManagement.origin")), 1),
                    _createVNode(_component_el_form_item, { prop: "make_in" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.formData.make_in,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.make_in) = $event)),
                          filterable: "",
                          clearable: "",
                          placeholder: 
                        _ctx.t('common.plsSelect') + _ctx.t('hsCodeManagement.origin')
                      ,
                          disabled: !!_ctx.editId,
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.originCountry, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.value + '(' + item.label + ')',
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "placeholder", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.t("hsCodeManagement.hsCode")), 1),
                    _createVNode(_component_el_form_item, { prop: "hs_code" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.hs_code,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.hs_code) = $event)),
                          type: "text",
                          placeholder: _ctx.t('common.plsEnter')
                        }, null, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ])), [
              [_directive_loading, _ctx.loading || _ctx.options.brandLoading]
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("button", {
                type: "reset",
                class: "btn btn-light me-3",
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.handleDiscard && _ctx.handleDiscard(...args)))
              }, [
                _createElementVNode("span", _hoisted_28, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.t("common.discard")), 1)
              ]),
              _createElementVNode("button", {
                ref: "submitButton",
                type: "submit",
                class: "btn btn-lg btn-primary",
                disabled: _ctx.loading || _ctx.options.brandLoading
              }, [
                _createElementVNode("span", _hoisted_30, [
                  _createElementVNode("span", _hoisted_31, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.t("common.submit")), 1)
                ]),
                _createElementVNode("span", _hoisted_32, [
                  _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                  _hoisted_33
                ])
              ], 8, _hoisted_29)
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ])
  ], 512))
}